import clsx from 'clsx';
import { Popover } from '@headlessui/react';
import { h, Fragment } from 'preact';
import { useThreekit } from '../threekit-context';
import ThreekitIcons from './threekit-icons';
import { useModal } from '../modal-context';
import FullScreenButton from '../full-screen-button';
import ThreekitMenuButton from '../threekit-menu-button';
import { socialShareModalName } from './modals/social-share-modal';

function ActionSheetButton({ mode = 'dropdown' }) {
  const { darkMode, getBackgroundColorFromSelectedVariant } = useThreekit();
  const { openModal } = useModal();
  const variantBackgroundColor = getBackgroundColorFromSelectedVariant();

  const renderModal = () => (
    <button
      onClick={() => openModal('Mobile Toolbar')}
      className={clsx(
        'flex items-center justify-center w-[40px] h-[40px] text-center rounded-sm cursor-pointer',
        {
          'text-black': !darkMode,
          'text-white': darkMode,
        },
      )}
    >
      <ThreekitIcons type="dotsMenu" />
    </button>
  );

  const renderDropdown = () => (
    <Popover className="relative">
      <style>
        {`:root{--dynamicBackground: ${variantBackgroundColor?.hex};}`}
      </style>
      <Popover.Button
        className={clsx(
          'flex items-center justify-center h-full w-[40px] text-center border-[0.6px] rounded-sm',
          {
            'laptop:border-black text-black': !darkMode,
            'laptop:border-white text-white': darkMode,
          },
        )}
      >
        <ThreekitIcons type="dotsMenu" />
      </Popover.Button>

      <Popover.Panel
        className={clsx(
          'absolute p-[10px] rounded-sm z-10 w-auto translate-x-[calc(-50%+20px)] translate-y-[14px]',
          {
            'bg-bg-2 bg-opacity-20': darkMode,
            'bg-bg-1': !darkMode,
          },
        )}
      >
        <div
          className={clsx(
            'absolute left-1/2 top-[-8px] transform -translate-x-1/2',
            {
              'text-bg-2 opacity-20': darkMode,
              'text-bg-1': !darkMode,
            },
          )}
        >
          <ThreekitIcons type="polygon" />
        </div>
        <div className="flex gap-[10px]">
          <button
            onClick={() => openModal(socialShareModalName)}
            className={clsx(
              'flex items-center justify-center w-[40px] h-[40px] text-center border-[0.6px] rounded cursor-pointer',
              {
                'border-black text-black hover:bg-dynamic hover:text-white':
                  !darkMode,
                'border-white text-white hover:bg-bg-1 hover:text-black':
                  darkMode,
              },
            )}
          >
            <ThreekitIcons type="share" />
          </button>
          <FullScreenButton
            className={clsx(
              'flex items-center justify-center w-[40px] h-[40px] text-center border-[0.6px] rounded cursor-pointer',
              {
                'border-black text-black hover:bg-dynamic hover:text-white':
                  !darkMode,
                'border-white text-white hover:bg-bg-1 hover:text-black':
                  darkMode,
              },
            )}
          />
          <ThreekitMenuButton
            className={clsx(
              'flex items-center justify-center w-[40px] h-[40px] text-center border-[0.6px] rounded cursor-pointer',
              {
                'border-black text-black hover:bg-dynamic hover:text-white':
                  !darkMode,
                'border-white text-white hover:bg-bg-1 hover:text-black':
                  darkMode,
              },
            )}
          />
        </div>
      </Popover.Panel>
    </Popover>
  );

  return (
    <>
      {mode === 'dropdown' && renderDropdown()}
      {mode === 'modal' && renderModal()}
    </>
  );
}

export default ActionSheetButton;
